import PropTypes from 'prop-types';
import { useEffect, useCallback, useRef } from 'react';
import { deprecate } from 'react-is-deprecated';
import { sendClick } from 'reaxl-analytics';

/**
 * Exposes the chat/text tagging event for 3rd party providers (Gubagoo and Active Engage)
 * to trigger when chat or text is clicked. Calling window.chatTextEventCallback with
 * 'text' or 'chat' will send a click event for 3rd party access.
 *
 * window.gubagooChatTextCall is an alias of window.chatTextEventCallback and is deprecated.
 */
function OwnerChatEvents(_ref) {
  let {
    listing = {},
    // deprecated
    ownerId,
    listingId,
    chatCallBack = () => {}
  } = _ref;
  // Temporary support for deprecated `listing` prop.
  if (!listingId && !ownerId) {
    listingId = listing?.id;
    ownerId = listing?.owner?.id;
  }
  const isChatTagFiredRef = useRef(false);
  const fireChatTextButtonEvent = useCallback(function (event, type, analyticsData) {
    if (type === void 0) {
      type = 'chatBox';
    }
    if (analyticsData === void 0) {
      analyticsData = {};
    }
    let handler;
    let cmp;
    switch (type) {
      case 'text':
        handler = 'ownerText';
        cmp = 'msg_slr';
        break;
      case 'chatCTA':
        handler = 'ownerChat';
        cmp = 'cs_chat';
        break;
      default:
        handler = 'ownerChat';
        cmp = 'ls_chat';
    }
    const data = {
      ...analyticsData,
      cmp,
      ownerId,
      inventoryId: listingId
    };

    // ownerChat event should fire only once per VDP
    if (handler === 'ownerChat' && isChatTagFiredRef.current === false) {
      sendClick(handler, event, data);
      if (typeof chatCallBack === 'function') {
        chatCallBack();
      }
      isChatTagFiredRef.current = true;
    } else if (handler === 'ownerText') {
      sendClick(handler, event, data);
    }
  }, [listingId, ownerId, chatCallBack]);
  useEffect(() => {
    isChatTagFiredRef.current = false;
  }, [listingId]);
  useEffect(() => {
    window.chatTextEventCallback = (type, analyticsData) => fireChatTextButtonEvent({}, type, analyticsData);
    window.gubagooChatTextCall = window.chatTextEventCallback;

    // create a function that will be used to overwrite _sendCustomAnalyticEvent from CarNow script
    window.carNowChatEventCallBack = eventData => eventData?.events === 'chatClick' && fireChatTextButtonEvent({}, eventData?.type);
    return () => {
      delete window.chatTextEventCallback;
      delete window.gubagooChatTextCall;
      delete window.carNowChatEventCallBack;
    };
  }, [fireChatTextButtonEvent]);
  return null;
}
export default OwnerChatEvents;